/*
 * @Author: changcheng
 * @LastEditTime: 2022-09-14 10:47:53
 */
export const echartCityData = [
  { code: "110000", name: "北京市", map: "北京" },
  { code: "120000", name: "天津市", map: "天津" },
  { code: "130000", name: "河北省", map: "河北" },
  { code: "140000", name: "山西省", map: "山西" },
  { code: "150000", name: "内蒙古自治区", map: "内蒙古" },
  { code: "210000", name: "辽宁省", map: "辽宁" },
  { code: "220000", name: "吉林省", map: "吉林" },
  { code: "230000", name: "黑龙江省", map: "黑龙江" },
  { code: "310000", name: "上海市", map: "上海" },
  { code: "320000", name: "江苏省", map: "江苏" },
  { code: "330000", name: "浙江省", map: "浙江" },
  { code: "340000", name: "安徽省", map: "安徽" },
  { code: "350000", name: "福建省", map: "福建" },
  { code: "360000", name: "江西省", map: "江西" },
  { code: "370000", name: "山东省", map: "山东" },
  { code: "410000", name: "河南省", map: "河南" },
  { code: "420000", name: "湖北省", map: "湖北" },
  { code: "430000", name: "湖南省", map: "湖南" },
  { code: "440000", name: "广东省", map: "广东" },
  { code: "450000", name: "广西壮族自治区", map: "广西" },
  { code: "460000", name: "海南省", map: "海南" },
  { code: "500000", name: "重庆市", map: "重庆" },
  { code: "510000", name: "四川省", map: "四川" },
  { code: "520000", name: "贵州省", map: "贵州" },
  { code: "530000", name: "云南省", map: "云南" },
  { code: "540000", name: "西藏自治区", map: "西藏" },
  { code: "610000", name: "陕西省", map: "陕西" },
  { code: "620000", name: "甘肃省", map: "甘肃" },
  { code: "630000", name: "青海省", map: "青海" },
  { code: "640000", name: "宁夏回族自治区", map: "宁夏" },
  { code: "650000", name: "新疆维吾尔自治区", map: "新疆" },
  { code: "710000", name: "台湾省", map: "台湾" },
  { code: "810000", name: "香港特别行政区", map: "香港" },
  { code: "820000", name: "澳门特别行政区", map: "澳门" },
];
